import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "brand navbar navbar-dark w-100" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "navbar-brand d-flex align-items-center",
        href: _ctx.routes.LANDING
      }, [
        _createElementVNode("img", {
          class: "brand-logo",
          src: _ctx.cdnUrl('/img/logo.png'),
          alt: "GanttProject Logo"
        }, null, 8, _hoisted_4),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "brand-name" }, "GanttProject Cloud", -1))
      ], 8, _hoisted_3),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}